/**
 * Рассчитать ежемесячный платеж
 *
 * loanAmount  - сумма кредитов, руб.
 * term - срок кредита, мес.
 */
export const calcMonthlyPayment = (loanAmount: number, term: number) =>
  Math.round(loanAmount / term)

/**
 * Рассчитать экономию в месяц
 *
 * payMonthlyNow - плачу сейчас ежемесячно, руб.
 * willPayMonthly - ежемесячный платеж, руб.
 */
export const calcMonthlySavings = (payMonthlyNow: number, willPayMonthly: number) =>
  Math.round(payMonthlyNow - willPayMonthly)
